import { Pipe, PipeTransform } from '@angular/core';
import {AppComponent} from "../app.component";

@Pipe({
  name: 'GetLabelPipe'
})
export class GetLabelPipe implements PipeTransform {

  transform(value: unknown, lowerUpper = -1, casing:object = null, sprintfArgs:(string|number)[] = null): unknown {
    //console.log('GetLabelPipe',lowerUpper,casing,sprintfArgs);
    return AppComponent.getLabel(value,lowerUpper,casing,sprintfArgs);
  }

}
